export const TOAST_MS = 3600

let toasts = []
let nextId = 1
const listeners = new Set()

const emit = () => listeners.forEach((notify) => notify())

export const showToast = (text) => {
  if (!text || toasts.some((t) => t.text === text)) return
  const id = nextId
  nextId += 1
  toasts = [...toasts, { id, text }]
  emit()
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id)
    emit()
  }, TOAST_MS)
}

export function useToasts() {
  const items = ref(toasts)
  const sync = () => {
    items.value = toasts
  }
  onMounted(() => {
    listeners.add(sync)
    sync()
  })
  onBeforeUnmount(() => {
    listeners.delete(sync)
  })
  return items
}
